import moment from 'moment';
import safeToBn from '@blockcatio/tabby-library/lib/utilities/safeToBn';

import getCampaignIdFromEvent from './getCampaignIdFromEvent';
import { CampaignStatuses } from '../constants';
import getCampaignStatus from './getCampaignStatus';

const eventToConfirmedCampaign = (event, timestamp = moment().unix()) => ({
  id: getCampaignIdFromEvent(event),
  name: event.returnValues.campaignName,
  tokenAddress: event.returnValues.token,
  sender: event.returnValues.sender,
  timestamp,
  tokensPerCode: safeToBn(event.returnValues.tokensPerCode),
  blockNumber: event.blockNumber,
  status: getCampaignStatus(CampaignStatuses.active),
  transactionHash: event.transactionHash,
  contract: event.contract,
  rewards: [],
  numberOfCodes: parseInt(event.returnValues.numberOfCodes, 10),
  hexId: event.returnValues.campaignId,
});

export default eventToConfirmedCampaign;



// WEBPACK FOOTER //
// ./src/utilities/eventToConfirmedCampaign.js